<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {

      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid">
          Creating a site that makes the visitor feel like they can collect valuable information and services without feeling like we are just trying to take advantage of them and capture a lead. Really give the look and feel of a non profit valuable resource.
        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
